export type WindowPoint = { x: number; y: number; scale?: number };

let currentWalletPoint: WindowPoint | null = null;

export const setWalletPoint = (point: WindowPoint) => {
	currentWalletPoint = point;
};

export const getWalletPoint = () => currentWalletPoint;
